module.exports = __webpack_public_path__ + "media/dashboard/rok-produkcji-9cd6c26b.svg";